(function(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object')
    module.exports = factory();
  else if (typeof define === 'function' && define.amd)
    define("serviceFactory", [], factory);
  else if (typeof exports === 'object')
    exports["serviceFactory"] = factory();
  else
    root["serviceFactory"] = factory();
})(this, function() {
  return function(request, reject, rootAddress) {
    var service = {};
    /**
		获取生成二维码所需要的信息
		请求方法: GET, POST
		请求示例: //ws.xoyo.com/jxsj/lwjhg190619/get_qrcode_info?aid=1

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "qrcodeFlagId": "1509693895174614",
		        "messageType": "15",
		        "app_session": "67395c9ddb945d2d829b0267cbbeafa74e07fd62"
		    }
		}
		*/
    service.getQrcodeInfo = function(aid) {
      return request.jsonp(rootAddress + '/jxsj/lwjhg/get_qrcode_info', {
        aid: aid /*  活动ID */
      }).then((response) => {
        if (response.status === 1 /* 成功 */ ) {
          /**
          {
            "data{}": {
              "qrcodeFlagId": "二维码标识ID",
              "messageType": "分享类型:15全民分享,16实物分享"
            }
          }
          		*/
          return response.data;
        }
        /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-20114",
          "description": "获取二维码信息失败"
        }, {
          "code": "-20127",
          "description": "活动ID不能为空"
        }, {
          "code": "-20128",
          "description": "活动不存在"
        }, {
          "code": "-20129",
          "description": "活动未开启"
        }, {
          "code": "-20130",
          "description": "活动未开始"
        }, {
          "code": "-20131",
          "description": "活动已结束"
        }, {
          "code": "-20134",
          "description": "分享功能未开启"
        }]
        		*/
        return reject(response);
      });
    };
    /**
		提交微信分享结果
		请求方法: GET, POST
		请求示例: //ws.xoyo.com/jxsj/lwjhg190619/submit_wechat_share_result?aid=1&qrcodeFlagId=1509693895174614

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "app_session": "67395c9ddb945d2d829b0267cbbeafa74e07fd62"
		    }
		}
		*/
    service.submitWechatShareResult = function(aid, qrcodeFlagId) {
      return request.jsonp(rootAddress + '/jxsj/lwjhg/submit_wechat_share_result', {
        aid: aid /*  活动ID */ ,
        qrcodeFlagId: qrcodeFlagId /*  二维码标识ID */
      }).then((response) => {
        if (response.status === 1 /* 成功 */ ) {
          /**
          {
            "data{}": []
          }
          		*/
          return response.data;
        }
        /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-12801",
          "description": "调用活动平台接口失败"
        }, {
          "code": "-12802",
          "description": "系统错误"
        }, {
          "code": "-12803",
          "description": "参数错误"
        }, {
          "code": "-12804",
          "description": "编码错误"
        }, {
          "code": "-12805",
          "description": "签名错误"
        }, {
          "code": "-12806",
          "description": "时间戳错误"
        }, {
          "code": "-12807",
          "description": "登录账号不存在"
        }, {
          "code": "-12808",
          "description": "玩家账号不存在"
        }, {
          "code": "-12809",
          "description": "区不存在"
        }, {
          "code": "-12810",
          "description": "流水号重复"
        }, {
          "code": "-12811",
          "description": "没有资格领取时间奖励"
        }, {
          "code": "-12812",
          "description": "已领取时间奖励"
        }, {
          "code": "-12813",
          "description": "未知错误"
        }, {
          "code": "-12814",
          "description": "游戏或者区服不存在"
        }, {
          "code": "-12815",
          "description": "未绑定手机号"
        }, {
          "code": "-12816",
          "description": "账号未登录"
        }, {
          "code": "-12817",
          "description": "操作失败"
        }, {
          "code": "-12818",
          "description": "账号已存在"
        }, {
          "code": "-12819",
          "description": "激活码不存在"
        }, {
          "code": "-12820",
          "description": "激活码已使用"
        }, {
          "code": "-12821",
          "description": "需要激活码"
        }, {
          "code": "-12822",
          "description": "游戏已关闭激活码激活玩家账号开关"
        }, {
          "code": "-12823",
          "description": "验证oldValue失败"
        }, {
          "code": "-12824",
          "description": "key不存在"
        }, {
          "code": "-12825",
          "description": "未知key类型"
        }, {
          "code": "-12826",
          "description": "网关名不存在"
        }, {
          "code": "-12827",
          "description": "大区内的账号不存在"
        }, {
          "code": "-12828",
          "description": "激活时间超时"
        }, {
          "code": "-12829",
          "description": "账号已申请过退款"
        }, {
          "code": "-12830",
          "description": "在线时长超时"
        }, {
          "code": "-12831",
          "description": "大区充值金额不足要求"
        }, {
          "code": "-12832",
          "description": "账号已是收费状态"
        }, {
          "code": "-12833",
          "description": "账号被冻结"
        }, {
          "code": "-12834",
          "description": "账号不允许充值"
        }, {
          "code": "-12835",
          "description": "查询账号数量超过16个"
        }, {
          "code": "-12836",
          "description": "账号不合法"
        }, {
          "code": "-12837",
          "description": "起始时间不能等于或晚于结束时间"
        }, {
          "code": "-12838",
          "description": "Paylog库访问异常"
        }, {
          "code": "-20112",
          "description": "微信分享失败"
        }, {
          "code": "-20118",
          "description": "微信分享请求参数错误"
        }, {
          "code": "-20119",
          "description": "全民分享未开始"
        }, {
          "code": "-20120",
          "description": "全民分享已结束"
        }, {
          "code": "-20121",
          "description": "实物分享未开始"
        }, {
          "code": "-20122",
          "description": "实物分享已结束"
        }, {
          "code": "-20127",
          "description": "活动ID不能为空"
        }, {
          "code": "-20128",
          "description": "活动不存在"
        }, {
          "code": "-20129",
          "description": "活动未开启"
        }, {
          "code": "-20130",
          "description": "活动未开始"
        }, {
          "code": "-20131",
          "description": "活动已结束"
        }, {
          "code": "-20132",
          "description": "全民分享未开启"
        }, {
          "code": "-20133",
          "description": "实物分享未开启"
        }, {
          "code": "-20134",
          "description": "分享功能未开启"
        }, {
          "code": "-20135",
          "description": "二维码标识ID不能为空"
        }]
        		*/
        return reject(response);
      });
    };
    /**
		获取玩家状态
		请求方法: GET, POST
		请求示例: //ws.xoyo.com/jxsj/lwjhg190619/get_player_status?aid=1

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "playerStatus": 3,
		        "newAccount": '',
		        "app_session": "ca32b9ac919053e46cfe0537bea75e875c054e3c"
		    }
		}
		*/
    service.getPlayerStatus = function(aid) {
      return request.jsonp(rootAddress + '/jxsj/lwjhg/get_player_status', {
        aid: aid /*  活动ID */
      }).then((response) => {
        if (response.status === 1 /* 成功 */ ) {
          /**
          {
            "data{}": {
              "playerStatus": "玩家状态 1:新玩家(未激活);2:新玩家(已激活);3:老玩家(未激活);4:老玩家(已激活);5:老玩家(已转移新账号并激活)",
              "newAccount": "新账号,playerStatus等于5时才会有值,其它情况为空"
            }
          }
          		*/
          return response.data;
        }
        /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-10201",
          "description": "系统处理中..."
        }, {
          "code": "-10402",
          "description": "请先登录"
        }, {
          "code": "-20127",
          "description": "活动ID不能为空"
        }, {
          "code": "-20128",
          "description": "活动不存在"
        }, {
          "code": "-20129",
          "description": "活动未开启"
        }, {
          "code": "-20130",
          "description": "活动未开始"
        }, {
          "code": "-20131",
          "description": "活动已结束"
        }]
        		*/
        return reject(response);
      });
    };
    /**
		获取当前账号绑定的手机号
		请求方法: GET, POST
		请求示例: //ws.xoyo.com/jxsj/lwjhg190619/get_bind_mobile?aid=1

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "displayMobile": "158****1516",
		        "mobile": "9f2161Gx3cAURpYR6M/mGoMDsW2asoGFXM/ehF5/n6TYFn7ihGpIsMfQ",
		        "app_session": "337c2ab16d3fa767d6730fa3bd979b3bed1ca1f0"
		    }
		}
		*/
    service.getBindMobile = function(aid) {
      return request.jsonp(rootAddress + '/jxsj/lwjhg/get_bind_mobile', {
        aid: aid /*  活动ID */
      }).then((response) => {
        if (response.status === 1 /* 成功 */ ) {
          /**
          {
            "data{}": {
              "displayMobile": "显示用的手机号",
              "mobile": "加密过后的手机号，发送短信验证码和验证短信验证码的时候mobile用这个参数"
            }
          }
          		*/
          return response.data;
        }
        /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-10402",
          "description": "请先登录"
        }, {
          "code": "-10405",
          "description": "账号不存在"
        }, {
          "code": "-20105",
          "description": "你还没有绑定手机号"
        }, {
          "code": "-20127",
          "description": "活动ID不能为空"
        }, {
          "code": "-20128",
          "description": "活动不存在"
        }, {
          "code": "-20129",
          "description": "活动未开启"
        }, {
          "code": "-20130",
          "description": "活动未开始"
        }, {
          "code": "-20131",
          "description": "活动已结束"
        }]
        		*/
        return reject(response);
      });
    };
    /**
		发送短信验证码
		请求方法: GET, POST
		请求示例: //ws.xoyo.com/jxsj/lwjhg190619/send_code?mobile=9c2d9d8yLi4D09kPcyXss9Nv/yZt4OKSVnkZ6W5yhDezlhq1NTM0ITQg&aid=1

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "app_session": "337c2ab16d3fa767d6730fa3bd979b3bed1ca1f0"
		    }
		}
		*/
    service.sendCode = function(aid, mobile, authParams) {
      return request.jsonp(rootAddress + '/jxsj/lwjhg/send_code', {
        aid: aid /*  活动ID */ ,
        mobile: mobile /*  手机号(加密过的手机号) */,
        ...authParams
      }).then((response) => {
        if (response.status === 1 /* 成功 */ ) {
          /**
          {
            "data{}": []
          }
          		*/
          return response.data;
        }
        /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-10101",
          "description": "手机号码为空"
        }, {
          "code": "-10102",
          "description": "手机号码格式错误"
        }, {
          "code": "-10303",
          "description": "短信内容为空"
        }, {
          "code": "-10305",
          "description": "短信发送手机号码为空"
        }, {
          "code": "-10306",
          "description": "短信发送手机号码格式错误"
        }, {
          "code": "-10308",
          "description": "短信验证码发送数量达到每日上限"
        }, {
          "code": "-10309",
          "description": "短信验证码发送频率太快"
        }, {
          "code": "-10601",
          "description": "图片验证码为空"
        }, {
          "code": "-10602",
          "description": "图片验证码错误"
        }, {
          "code": "-10603",
          "description": "验证失败"
        }, {
          "code": "-10604",
          "description": "图片验证码参数错误"
        }, {
          "code": "-20113",
          "description": "手机号不能为空"
        }, {
          "code": "-20127",
          "description": "活动ID不能为空"
        }, {
          "code": "-20128",
          "description": "活动不存在"
        }, {
          "code": "-20129",
          "description": "活动未开启"
        }, {
          "code": "-20130",
          "description": "活动未开始"
        }, {
          "code": "-20131",
          "description": "活动已结束"
        }]
        		*/
        return reject(response);
      });
    };
    /**
		验证身份证
		请求方法: GET, POST
		请求示例: //ws.xoyo.com/jxsj/lwjhg190619/check_id_card?idCard=441581199205192376&aid=1

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "app_session": "337c2ab16d3fa767d6730fa3bd979b3bed1ca1f0"
		    }
		}
		*/
    service.checkIdCard = function(aid, idCard) {
      return request.jsonp(rootAddress + '/jxsj/lwjhg/check_id_card', {
        aid: aid /*  活动ID */ ,
        idCard: idCard /*  身份证 */
      }).then((response) => {
        if (response.status === 1 /* 成功 */ ) {
          /**
          {
            "data{}": []
          }
          		*/
          return response.data;
        }
        /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-10107",
          "description": "身份证号码为空"
        }, {
          "code": "-10108",
          "description": "身份证号码格式错误"
        }, {
          "code": "-10402",
          "description": "请先登录"
        }, {
          "code": "-10405",
          "description": "账号不存在"
        }, {
          "code": "-20103",
          "description": "该账号绑定的身份证和填写的身份证不一致，如大侠遗忘绑定身份证账号信息，请致电客服热线：028-85437733。"
        }, {
          "code": "-20106",
          "description": "你还没有绑定身份证"
        }, {
          "code": "-20107",
          "description": "身份证不能为空"
        }, {
          "code": "-20127",
          "description": "活动ID不能为空"
        }, {
          "code": "-20128",
          "description": "活动不存在"
        }, {
          "code": "-20129",
          "description": "活动未开启"
        }, {
          "code": "-20130",
          "description": "活动未开始"
        }, {
          "code": "-20131",
          "description": "活动已结束"
        }]
        		*/
        return reject(response);
      });
    };
    /**
		验证短信验证码
		请求方法: GET, POST
		请求示例: //ws.xoyo.com/jxsj/lwjhg190619/check_code?mobile=9c2d9d8yLi4D09kPcyXss9Nv/yZt4OKSVnkZ6W5yhDezlhq1NTM0ITQg&verifyCode=123456&aid=1

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "app_session": "337c2ab16d3fa767d6730fa3bd979b3bed1ca1f0"
		    }
		}
		*/
    service.checkCode = function(aid, mobile, verifyCode) {
      return request.jsonp(rootAddress + '/jxsj/lwjhg/check_code', {
        aid: aid /*  活动ID */ ,
        mobile: mobile /*  手机号(加密过的手机号) */ ,
        verifyCode: verifyCode /*  验证码 */
      }).then((response) => {
        if (response.status === 1 /* 成功 */ ) {
          /**
          {
            "data{}": []
          }
          		*/
          return response.data;
        }
        /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-10305",
          "description": "短信发送手机号码为空"
        }, {
          "code": "-10306",
          "description": "短信发送手机号码格式错误"
        }, {
          "code": "-10310",
          "description": "短信验证码不存在"
        }, {
          "code": "-10311",
          "description": "短信验证码为空"
        }, {
          "code": "-10312",
          "description": "短信验证码错误"
        }, {
          "code": "-10313",
          "description": "短信验证码超过有效期"
        }, {
          "code": "-10314",
          "description": "短信验证码已失效"
        }, {
          "code": "-20108",
          "description": "验证码不能为空"
        }, {
          "code": "-20113",
          "description": "手机号不能为空"
        }, {
          "code": "-20127",
          "description": "活动ID不能为空"
        }, {
          "code": "-20128",
          "description": "活动不存在"
        }, {
          "code": "-20129",
          "description": "活动未开启"
        }, {
          "code": "-20130",
          "description": "活动未开始"
        }, {
          "code": "-20131",
          "description": "活动已结束"
        }]
        		*/
        return reject(response);
      });
    };
    /**
		判断新账号是否可以转移
		请求方法: GET, POST
		请求示例: //ws.xoyo.com/jxsj/lwjhg190619/check_new_account?aid=1&newAccount=test1001

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "app_session": "a3ac8ea206d11e2cb6b56f92882a1b27ecb5b05a"
		    }
		}
		*/
    service.checkNewAccount = function(aid, newAccount) {
      return request.jsonp(rootAddress + '/jxsj/lwjhg/check_new_account', {
        aid: aid /*  活动ID */ ,
        newAccount: newAccount /*  新账号 */
      }).then((response) => {
        if (response.status === 1 /* 成功 */ ) {
          /**
          {
            "data{}": []
          }
          		*/
          return response.data;
        }
        /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-10201",
          "description": "系统处理中..."
        }, {
          "code": "-10402",
          "description": "请先登录"
        }, {
          "code": "-10403",
          "description": "账号不能为空"
        }, {
          "code": "-10405",
          "description": "账号不存在"
        }, {
          "code": "-20101",
          "description": "新账号不能为空"
        }, {
          "code": "-20110",
          "description": "账号不存在，请核证后再试！"
        }, {
          "code": "-20115",
          "description": "该账号已经激活，无需转移"
        }, {
          "code": "-20116",
          "description": "该账号已有特权，无法进行转移！"
        }, {
          "code": "-20127",
          "description": "活动ID不能为空"
        }, {
          "code": "-20128",
          "description": "活动不存在"
        }, {
          "code": "-20129",
          "description": "活动未开启"
        }, {
          "code": "-20130",
          "description": "活动未开始"
        }, {
          "code": "-20131",
          "description": "活动已结束"
        }]
        		*/
        return reject(response);
      });
    };
    /**
		激活账号
		请求方法: GET, POST
		请求示例: //ws.xoyo.com/jxsj/lwjhg190619/activation_account?aid=1&newAccount=xsjcs_0002

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "app_session": "337c2ab16d3fa767d6730fa3bd979b3bed1ca1f0"
		    }
		}
		*/
    service.activationAccount = function(aid, newAccount) {
      return request.jsonp(rootAddress + '/jxsj/lwjhg/activation_account', {
        aid: aid /*  活动ID */ ,
        newAccount: newAccount /*  新账号,有值代表转移资格至新账号并激活,无值代表激活新账号或者老账号 */
      }).then((response) => {
        if (response.status === 1 /* 成功 */ ) {
          /**
          {
            "data{}": []
          }
          		*/
          return response.data;
        }
        /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-10201",
          "description": "系统处理中..."
        }, {
          "code": "-10402",
          "description": "请先登录"
        }, {
          "code": "-10403",
          "description": "账号不能为空"
        }, {
          "code": "-10405",
          "description": "账号不存在"
        }, {
          "code": "-12801",
          "description": "调用活动平台接口失败"
        }, {
          "code": "-12802",
          "description": "系统错误"
        }, {
          "code": "-12803",
          "description": "参数错误"
        }, {
          "code": "-12804",
          "description": "编码错误"
        }, {
          "code": "-12805",
          "description": "签名错误"
        }, {
          "code": "-12806",
          "description": "时间戳错误"
        }, {
          "code": "-12807",
          "description": "登录账号不存在"
        }, {
          "code": "-12808",
          "description": "玩家账号不存在"
        }, {
          "code": "-12809",
          "description": "区不存在"
        }, {
          "code": "-12810",
          "description": "流水号重复"
        }, {
          "code": "-12811",
          "description": "没有资格领取时间奖励"
        }, {
          "code": "-12812",
          "description": "已领取时间奖励"
        }, {
          "code": "-12813",
          "description": "未知错误"
        }, {
          "code": "-12814",
          "description": "游戏或者区服不存在"
        }, {
          "code": "-12815",
          "description": "未绑定手机号"
        }, {
          "code": "-12816",
          "description": "账号未登录"
        }, {
          "code": "-12817",
          "description": "操作失败"
        }, {
          "code": "-12818",
          "description": "账号已存在"
        }, {
          "code": "-12819",
          "description": "激活码不存在"
        }, {
          "code": "-12820",
          "description": "激活码已使用"
        }, {
          "code": "-12821",
          "description": "需要激活码"
        }, {
          "code": "-12822",
          "description": "游戏已关闭激活码激活玩家账号开关"
        }, {
          "code": "-12823",
          "description": "验证oldValue失败"
        }, {
          "code": "-12824",
          "description": "key不存在"
        }, {
          "code": "-12825",
          "description": "未知key类型"
        }, {
          "code": "-12826",
          "description": "网关名不存在"
        }, {
          "code": "-12827",
          "description": "大区内的账号不存在"
        }, {
          "code": "-12828",
          "description": "激活时间超时"
        }, {
          "code": "-12829",
          "description": "账号已申请过退款"
        }, {
          "code": "-12830",
          "description": "在线时长超时"
        }, {
          "code": "-12831",
          "description": "大区充值金额不足要求"
        }, {
          "code": "-12832",
          "description": "账号已是收费状态"
        }, {
          "code": "-12833",
          "description": "账号被冻结"
        }, {
          "code": "-12834",
          "description": "账号不允许充值"
        }, {
          "code": "-12835",
          "description": "查询账号数量超过16个"
        }, {
          "code": "-12836",
          "description": "账号不合法"
        }, {
          "code": "-12837",
          "description": "起始时间不能等于或晚于结束时间"
        }, {
          "code": "-12838",
          "description": "Paylog库访问异常"
        }, {
          "code": "-20101",
          "description": "新账号不能为空"
        }, {
          "code": "-20105",
          "description": "你还没有绑定手机号"
        }, {
          "code": "-20106",
          "description": "你还没有绑定身份证"
        }, {
          "code": "-20109",
          "description": "该账号已激活"
        }, {
          "code": "-20110",
          "description": "账号不存在，请核证后再试！"
        }, {
          "code": "-20111",
          "description": "激活账号失败"
        }, {
          "code": "-20115",
          "description": "该账号已经激活，无需转移"
        }, {
          "code": "-20116",
          "description": "该账号已有特权，无法进行转移！"
        }, {
          "code": "-20117",
          "description": "输入的账号与当前账号相同，请重新输入！"
        }, {
          "code": "-20123",
          "description": "新账号激活未开启"
        }, {
          "code": "-20124",
          "description": "该绑定手机已激活账号的次数达到了上限"
        }, {
          "code": "-20125",
          "description": "该绑定身份证已激活账号的次数达到了上限"
        }, {
          "code": "-20126",
          "description": "该账号没有资格"
        }, {
          "code": "-20127",
          "description": "活动ID不能为空"
        }, {
          "code": "-20128",
          "description": "活动不存在"
        }, {
          "code": "-20129",
          "description": "活动未开启"
        }, {
          "code": "-20130",
          "description": "活动未开始"
        }, {
          "code": "-20131",
          "description": "活动已结束"
        }, {
          "code": "-20136",
          "description": "激活功能未开启"
        }]
        		*/
        return reject(response);
      });
    };
    /**
		获取鉴定结果
		请求方法: GET, POST
		请求示例: //<domain>/jxsj/lwjhg190619/get_identify_result?aid=1

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "result": {
		            "id": 7,
		            "account": "15814871772",
		            "status": "0",
		            "aid": "1",
		            "duration": "20",
		            "level": "4",
		            "value": "12000",
		            "last_login_time": "2019-06-10",
		            "create_time": "2019-01-01",
		            "diff_day": "9",
		            "bind_money": 1200000
		        },
		        "is_open": "1",
		        "session_id": "fjvbDnVoZo4ZpvSTECUz9NcvdRlbqdpiTRzKYSIl",
		        "request_id": "8c3f6679626b5df358df9293e657da220d7a89bd"
		    }
		}
		*/
    service.getIdentifyResult = function(aid) {
      return request.jsonp(rootAddress + '/jxsj/lwjhg/get_identify_result', {
        aid: aid /*  活动ID */
      }).then((response) => {
        if (response.status === 1 /* 成功 */ ) {
          /**
          {
            "data{}": {
              "is_open": "是否开启古董账号(1开启 0关闭)",
              "result": "结果列表"
            },
            "data{}.result{}": {
              "account": "账号",
              "aid": "活动ID",
              "bind_money": "绑金",
              "create_time": "创建时间",
              "diff_day": "离开天数",
              "duration": "在线时长",
              "id": "ID",
              "last_login_time": "最后登录时间",
              "level": "等级(0无等级 1雏凤 2潜龙 3至尊 4无双 5超神)",
              "status": "激活状态（1激活 0未激活）",
              "value": "价值"
            }
          }
          		*/
          return response.data;
        }
        /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-10201",
          "description": "系统处理中..."
        }, {
          "code": "-10402",
          "description": "请先登录"
        }, {
          "code": "-20127",
          "description": "活动ID不能为空"
        }, {
          "code": "-20128",
          "description": "活动不存在"
        }, {
          "code": "-20129",
          "description": "活动未开启"
        }, {
          "code": "-20130",
          "description": "活动未开始"
        }, {
          "code": "-20131",
          "description": "活动已结束"
        }]
        		*/
        return reject(response);
      });
    };
    /**
		获取激活结果
		请求方法: GET, POST
		请求示例: //<domain>/jxsj/lwjhg190619/get_activation_result?aid=1

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "level": "混天",
		        "value": 1000000,
		        "new_account": "",
		        "type": 1,
		        "session_id": "YjpMVtS4Y4X6cF3auuDHuSEL4KSR69seC8phCwIE",
		        "request_id": "577bbd81445f1f676849f71a464c7e2e13c2efdd"
		    }
		}
		*/
    service.getActivationResult = function(aid) {
      return request.jsonp(rootAddress + '/jxsj/lwjhg/get_activation_result', {
        aid: aid /*  活动ID */
      }).then((response) => {
        if (response.status === 1 /* 成功 */ ) {
          /**
          {
            "data{}": {
              "level": "等级(0无等级 1雏凤 2潜龙 3至尊 4无双 5超神)",
              "new_account": "新账号",
              "type": "(激活结果类型：1普通激活 2未转移 3已转移 4获得转移)",
              "value": "价值"
            }
          }
          		*/
          return response.data;
        }
        /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-10201",
          "description": "系统处理中..."
        }, {
          "code": "-10402",
          "description": "请先登录"
        }, {
          "code": "-20127",
          "description": "活动ID不能为空"
        }, {
          "code": "-20128",
          "description": "活动不存在"
        }, {
          "code": "-20129",
          "description": "活动未开启"
        }, {
          "code": "-20130",
          "description": "活动未开始"
        }, {
          "code": "-20131",
          "description": "活动已结束"
        }]
        		*/
        return reject(response);
      });
    };
    /**
		计算鉴定账号数(登录调用)
		请求方法: GET, POST
		请求示例: //<domain>/jxsj/lwjhg190619/sadd_identify?aid=1

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "session_id": "cheZME8cNSgNxOTYqH49zuFtrkrkNlFfn3WtVJwf",
		        "request_id": "3fb2d4401d3c07ffe3618be46bccc3fffc240035"
		    }
		}
		*/
    service.saddIdentify = function(aid) {
      return request.jsonp(rootAddress + '/jxsj/lwjhg/sadd_identify', {
        aid: aid /*  活动ID */
      }).then((response) => {
        if (response.status === 1 /* 成功 */ ) {
          /**
          {
            "data{}": []
          }
          		*/
          return response.data;
        }
        /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-10402",
          "description": "请先登录"
        }, {
          "code": "-20127",
          "description": "活动ID不能为空"
        }, {
          "code": "-20128",
          "description": "活动不存在"
        }, {
          "code": "-20129",
          "description": "活动未开启"
        }, {
          "code": "-20130",
          "description": "活动未开始"
        }, {
          "code": "-20131",
          "description": "活动已结束"
        }]
        		*/
        return reject(response);
      });
    };
    /**
		获取鉴定账号总数
		请求方法: GET, POST
		请求示例: //<domain>/jxsj/lwjhg190619/get_identify_total?aid=1

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "total": 4,
		        "session_id": "cheZME8cNSgNxOTYqH49zuFtrkrkNlFfn3WtVJwf",
		        "request_id": "d2b533a8726d0bbf6627df69658e0bb2a3f6a43c"
		    }
		}
		*/
    service.getIdentifyTotal = function(aid) {
      return request.jsonp(rootAddress + '/jxsj/lwjhg/get_identify_total', {
        aid: aid /*  活动ID */
      }).then((response) => {
        if (response.status === 1 /* 成功 */ ) {
          /**
          {
            "data{}": {
              "total": "鉴定账号总数"
            }
          }
          		*/
          return response.data;
        }
        /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-20127",
          "description": "活动ID不能为空"
        }, {
          "code": "-20128",
          "description": "活动不存在"
        }, {
          "code": "-20129",
          "description": "活动未开启"
        }, {
          "code": "-20130",
          "description": "活动未开始"
        }, {
          "code": "-20131",
          "description": "活动已结束"
        }]
        		*/
        return reject(response);
      });
    };
    /**
		获取分享token
		请求方法: GET, POST
		请求示例: //<domain>/jxsj/lwjhg190619/get_share_token?aid=1

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "share_token": "c71250ce9ee687720f79ebbe837e99c2",
		        "session_id": "cheZME8cNSgNxOTYqH49zuFtrkrkNlFfn3WtVJwf",
		        "request_id": "2d25d89adbf4bb7810724f3e6222570e9129c692"
		    }
		}
		*/
    service.getShareToken = function(aid) {
      return request.jsonp(rootAddress + '/jxsj/lwjhg/get_share_token', {
        aid: aid /*  活动ID */
      }).then((response) => {
        if (response.status === 1 /* 成功 */ ) {
          /**
          {
            "data{}": {
              "share_token": "分享标识"
            }
          }
          		*/
          return response.data;
        }
        /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-10402",
          "description": "请先登录"
        }, {
          "code": "-20127",
          "description": "活动ID不能为空"
        }, {
          "code": "-20128",
          "description": "活动不存在"
        }, {
          "code": "-20129",
          "description": "活动未开启"
        }, {
          "code": "-20130",
          "description": "活动未开始"
        }, {
          "code": "-20131",
          "description": "活动已结束"
        }]
        		*/
        return reject(response);
      });
    };
    /**
		获取配置
		请求方法: GET, POST
		请求示例: //<domain>/jxsj/lwjhg190619/get_config?aid=1&share_token=c71250ce9ee687720f79ebbe837e99c2

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "activity_time": {
		            "begin_time": "2019-06-10 00:00:00",
		            "end_time": "2019-07-31 00:00:00"
		        },
		        "status": "1",
		        "increase_activity_time": {
		            "begin": 1560182400,
		            "end": 1564502400
		        },
		        "share_account": "15814871772",
		        "value": "1999",
		        "session_id": "cheZME8cNSgNxOTYqH49zuFtrkrkNlFfn3WtVJwf",
		        "request_id": "f0ed29f547c7d8db0aa66989e4ad688d7196b8fd"
		    }
		}
		*/
    service.getConfig = function(aid, share_token) {
      return request.jsonp(rootAddress + '/jxsj/lwjhg/get_config', {
        aid: aid /*  活动ID */ ,
        share_token: share_token /*  分享标识 */
      }).then((response) => {
        if (response.status === 1 /* 成功 */ ) {
          /**
          {
            "data{}": {
              "activity_time": "古董账号活动时间",
              "increase_activity_time": "加价功能活动时间",
              "share_account": "分享UID",
              "status": "激活状态（1激活 0未激活）",
              "value": "价值"
            },
            "data{}.activity_time{}": {
              "begin_time": "开始时间",
              "end_time": "结束时间"
            },
            "data{}.increase_activity_time{}": {
              "begin": "开始时间",
              "end": "结束时间"
            }
          }
          		*/
          return response.data;
        }
        /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-10402",
          "description": "请先登录"
        }, {
          "code": "-20127",
          "description": "活动ID不能为空"
        }, {
          "code": "-20128",
          "description": "活动不存在"
        }, {
          "code": "-20129",
          "description": "活动未开启"
        }, {
          "code": "-20130",
          "description": "活动未开始"
        }, {
          "code": "-20131",
          "description": "活动已结束"
        }, {
          "code": "-20144",
          "description": "加价活动未开始"
        }, {
          "code": "-20145",
          "description": "加价活动已结束"
        }, {
          "code": "-20146",
          "description": "分享TOKEN为空"
        }, {
          "code": "-20147",
          "description": "分享TOKEN错误"
        }, {
          "code": "-20154",
          "description": "加价活动开启结束时间未设置"
        }]
        		*/
        return reject(response);
      });
    };
    /**
		加价
		请求方法: GET, POST
		请求示例: //<domain>/jxsj/lwjhg190619/increase_price?aid=1&share_token=c71250ce9ee687720f79ebbe837e99c2

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "incr_price": 10000,
		        "is_login_passport": 1,
		        "total_increase_price": 20000,
		        "session_id": "cheZME8cNSgNxOTYqH49zuFtrkrkNlFfn3WtVJwf",
		        "request_id": "f069170feacb1f54fcfaa395c4ac1bdc7246a0db"
		    }
		}
		*/
    service.increasePrice = function(aid, share_token) {
      return request.jsonp(rootAddress + '/jxsj/lwjhg/increase_price', {
        aid: aid /*  活动ID */ ,
        share_token: share_token /*  分享token */
      }).then((response) => {
        if (response.status === 1 /* 成功 */ ) {
          /**
          {
            "data{}": {
              "auth_url": "微信授权地址(在需要微信授权的场景下会返回此字段)",
              "incr_price": "增加的绑金",
              "is_login_passport": "是否登录通行证（1是 0否）",
              "total_increase_price": "总绑金金额"
            }
          }
          		*/
          return response.data;
        }
        /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-10402",
          "description": "请先登录"
        }, {
          "code": "-10801",
          "description": "请先微信授权"
        }, {
          "code": "-20127",
          "description": "活动ID不能为空"
        }, {
          "code": "-20128",
          "description": "活动不存在"
        }, {
          "code": "-20129",
          "description": "活动未开启"
        }, {
          "code": "-20130",
          "description": "活动未开始"
        }, {
          "code": "-20131",
          "description": "活动已结束"
        }, {
          "code": "-20143",
          "description": "加价功能未开启"
        }, {
          "code": "-20144",
          "description": "加价活动未开始"
        }, {
          "code": "-20145",
          "description": "加价活动已结束"
        }, {
          "code": "-20146",
          "description": "分享TOKEN为空"
        }, {
          "code": "-20147",
          "description": "分享TOKEN错误"
        }, {
          "code": "-20148",
          "description": "不能为自己加价哦～"
        }, {
          "code": "-20151",
          "description": "今天加价次数已达上限，请明日再来！"
        }, {
          "code": "-20152",
          "description": "今天加价好友数已达上限，请明日再来！"
        }, {
          "code": "-20153",
          "description": "该账号已经价值飙升，达到加价上限啦～"
        }, {
          "code": "-20154",
          "description": "加价活动开启结束时间未设置"
        }]
        		*/
        return reject(response);
      });
    };
    /**
		获取加价列表
		请求方法: GET, POST
		请求示例: //<domain>/jxsj/lwjhg190619/get_increase_list?aid=1&share_token=39b8fd30b84aa783b7a98b797db57cca

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "list": [
		            {
		                "account": "49279d768daa0b1ba309c2854932606",
		                "nick_name": "梁鸿宝",
		                "head_img_url": "//wx.qlogo.cn/mmopen/mbdcgRg42DZtROPSTQBEyMRznpc20J6BzusAscCKjVOKVk9QoaCEQlkxAXZFEovCP38uaJKzzPibXeibz5oRs8oopvtkMuscoF/0",
		                "create_time": "1560759085",
		                "sum_price": "11000"
		            },
		            {
		                "account": "49279d768daa0b1ba309c2854939436",
		                "nick_name": "梁鸿宝",
		                "head_img_url": "//wx.qlogo.cn/mmopen/mbdcgRg42DZtROPSTQBEyMRznpc20J6BzusAscCKjVOKVk9QoaCEQlkxAXZFEovCP38uaJKzzPibXeibz5oRs8oopvtkMuscoF/0",
		                "create_time": "1560759120",
		                "sum_price": "10000"
		            },
		            {
		                "account": "49279d768daa0b1ba309c2854990418",
		                "nick_name": "梁鸿宝",
		                "head_img_url": "//wx.qlogo.cn/mmopen/mbdcgRg42DZtROPSTQBEyMRznpc20J6BzusAscCKjVOKVk9QoaCEQlkxAXZFEovCP38uaJKzzPibXeibz5oRs8oopvtkMuscoF/0",
		                "create_time": "1560759123",
		                "sum_price": "10000"
		            }
		        ],
		        "session_id": "cheZME8cNSgNxOTYqH49zuFtrkrkNlFfn3WtVJwf",
		        "request_id": "42911dc55d8bee3f68024481da631309983cad7c"
		    }
		}
		*/
    service.getIncreaseList = function(aid, share_token) {
      return request.jsonp(rootAddress + '/jxsj/lwjhg/get_increase_list', {
        aid: aid /*  活动ID */ ,
        share_token: share_token /*  分享token */
      }).then((response) => {
        if (response.status === 1 /* 成功 */ ) {
          /**
          {
            "data{}": {
              "list": "加价列表"
            },
            "data{}.list[]": {
              "account": "微信UID账号",
              "create_time": "创建时间",
              "head_img_url": "头像地址",
              "nick_name": "昵称",
              "sum_price": "总加价"
            }
          }
          		*/
          return response.data;
        }
        /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-20127",
          "description": "活动ID不能为空"
        }, {
          "code": "-20128",
          "description": "活动不存在"
        }, {
          "code": "-20129",
          "description": "活动未开启"
        }, {
          "code": "-20130",
          "description": "活动未开始"
        }, {
          "code": "-20131",
          "description": "活动已结束"
        }, {
          "code": "-20146",
          "description": "分享TOKEN为空"
        }, {
          "code": "-20147",
          "description": "分享TOKEN错误"
        }]
        		*/
        return reject(response);
      });
    };
    /**
		根据share_token获取加价总绑金金额
		请求方法: GET, POST
		请求示例: //<domain>/jxsj/lwjhg190619/get_total_increase_by_token?aid=1&share_token=39b8fd30b84aa783b7a98b797db57cca

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "total": "150000",
		        "session_id": "cheZME8cNSgNxOTYqH49zuFtrkrkNlFfn3WtVJwf",
		        "request_id": "6129b4830f91dd98d61fb05cebb04ae46fffaa14"
		    }
		}
		*/
    service.getTotalIncreaseByToken = function(aid, share_token) {
      return request.jsonp(rootAddress + '/jxsj/lwjhg/get_total_increase_by_token', {
        aid: aid /*  活动ID */ ,
        share_token: share_token /*  分享token */
      }).then((response) => {
        if (response.status === 1 /* 成功 */ ) {
          /**
          {
            "data{}": {
              "total": "加价总绑金金额"
            }
          }
          		*/
          return response.data;
        }
        /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-10402",
          "description": "请先登录"
        }, {
          "code": "-20127",
          "description": "活动ID不能为空"
        }, {
          "code": "-20128",
          "description": "活动不存在"
        }, {
          "code": "-20129",
          "description": "活动未开启"
        }, {
          "code": "-20130",
          "description": "活动未开始"
        }, {
          "code": "-20131",
          "description": "活动已结束"
        }, {
          "code": "-20146",
          "description": "分享TOKEN为空"
        }, {
          "code": "-20147",
          "description": "分享TOKEN错误"
        }]
        		*/
        return reject(response);
      });
    };
    return service;
  }
});



// WEBPACK FOOTER //
// ./src/services/zt/zt.js